import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  HarmonizedTariffScheduleBean,
  HTSSearchCriteria,
  RestHarmonizedTariffScheduleListRequest,
  RestReadRequest,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmptyArray } from "../gui_components/Util.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class HarmonizedTariffScheduleListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
  }

  componentDidMount() {}
  componentDidUpdate() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  opentypeforms = (e) => {
    if (e.detail === 1) this.props.opentypeforms();
  };
  editHarmonizedTariffSchedule = (e, rowdata) => {
    if (e.detail === 1) this.props.editHarmonizedTariffSchedule(rowdata);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  deleteOnClick = (e, val, rowData) => {
    if (e.detail === 1) this.props.deleteOnClick(val, rowData);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  render() {
    let harmonizedTariffSchedule_list =
      this.props.harmonizedTariffSchedule_list;
    let harmonizedTariffScheduleData = this.props.harmonizedTariffScheduleData;
    return (
      <div>
        <Row>
          <Col sm="2">
            <FormLabel id="searchBarLabel">
              Harmonized Tariff Schedule
            </FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={this.listFormCodeRef}
              name="code"
              onChange={this.onChange}
              value={harmonizedTariffScheduleData.code}
              style={{ "text-transform": "uppercase" }}
              enterKeyEventHandler={this.enterKeyEventHandler}
              isMandatory={true}
            ></InputTextbox>
          </Col>

          <Col sm="1">
            <Button
              id="fabric_Add_Button"
              className="text-center"
              onClick={(e) => this.opentypeforms(e)}
            >
              Go
            </Button>
          </Col>
        </Row>

        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {/* <th>Remove</th> */}
              </tr>
            </thead>
            <tbody>
              {harmonizedTariffSchedule_list.map((Info, index) => (
                <tr key={index}>
                  <td>
                    <Button
                      variant="secondry"
                      className="td_attribute_width"
                      onClick={(e) =>
                        this.editHarmonizedTariffSchedule(e, Info.code, Info)
                      }
                    >
                      {Info.code}
                    </Button>
                  </td>
                  <td> {Info.description}</td>
                  <td>{Info.companyCode}</td>
                  <td>{Info.isActive}</td>
                  {/* <td className="text-right">
                    <Button
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) => this.deleteOnClick(e, Info.code, Info)}
                    >
                      {<DeleteIcon />}
                    </Button>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}

class HarmonizedTariffScheduleEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
  }

  componentDidMount() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  render() {
    let harmonizedTariffScheduleData = this.props.harmonizedTariffScheduleData;
    let isDisableFields = this.props.isDisableFields;

    return (
      <div>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Company Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="companyCode"
              type="text"
              placeholder="Enter CompanyCode"
              onChange={this.onChange}
              value={harmonizedTariffScheduleData.companyCode}
              disabled={true}
            />{" "}
          </Col>
          <Col sm="2">
            {" "}
            <FormLabel>HarmonizedTariffSchedule</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              ref={this.codeRef}
              name="code"
              type="text"
              placeholder="Enter HarmonizedTariffScheduleCode"
              onChange={this.onChange}
              value={harmonizedTariffScheduleData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisableFields}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="2">
            <FormLabel>HarmonizedTariffSchedule Name</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter Name"
              onChange={this.onChange}
              value={harmonizedTariffScheduleData.description}
              style={{ "text-transform": "capitalize" }}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>Active</FormLabel>
          </Col>
          <Col sm="1">
            {" "}
            <InputCheckbox
              type="checkbox"
              name="isActive"
              onChange={this.onChange}
              checked={harmonizedTariffScheduleData.isActive}
            />
          </Col>
        </Row>

        <br />
      </div>
    );
  }
}

class HarmonizedTariffScheduleList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      harmonizedTariffSchedule_list: [],
      response: {},
      pageTitle: "Harmonized Tariff Schedule",
      harmonizedTariffScheduleData: new HarmonizedTariffScheduleBean(),
      pageList: new PageListBean(),
      criteria: new HTSSearchCriteria(),
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowExitButton: true,
      isShowBackButton: false,
      error_list: [],
      totalCount: 0,
      isHarmonizedTariffScheduleListFormOpen: true,
      isHarmonizedTariffScheduleEntryFormOpen: false,
      isShowNodes: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowExitButton: true,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
      order: "asc",
      sortField: "",
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    let harmonizedTariffScheduleData = new HarmonizedTariffScheduleBean();
    harmonizedTariffScheduleData.companyCode = this.companyCode;
    this.loadPage(1);
    this.cleardata();
  }

  moduleCaption = "Harmonized Tariff Schedule";

  openeditform = () => {
    this.openHarmonizedTariffScheduleEntryForm();
  };

  cleardata = () => {
    let harmonizedTariffScheduleData = new HarmonizedTariffScheduleBean();
    harmonizedTariffScheduleData.companyCode = this.companyCode;
    this.setState({
      harmonizedTariffScheduleData: harmonizedTariffScheduleData,
    });
  };
  saveHarmonizedTariffScheduleResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
    this.cleardata();
    this.closeHarmonizedTariffScheduleEntryForm();
  };

  saveHarmonizedTariffSchedule = () => {
    let harmonizedTariffScheduleData = this.state.harmonizedTariffScheduleData;
    if (harmonizedTariffScheduleData.isFetched == true) {
      if (
        SecurityAccessManager.HarmonizedTariffScheduleMaintenanceEdit_IsAccessible()
      ) {
        MasterService.updateHarmonizedTariffSchedule(
          harmonizedTariffScheduleData,
          this.saveHarmonizedTariffScheduleResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (
        SecurityAccessManager.HarmonizedTariffScheduleMaintenanceCreate_IsAccessible()
      ) {
        MasterService.createHarmonizedTariffSchedule(
          harmonizedTariffScheduleData,
          this.saveHarmonizedTariffScheduleResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };

  editHarmonizedTariffScheduleResponse = (response) => {
    if (response.data != null) {
      if (response.data.htsBean != null) {
        let harmonizedTariffScheduleData = response.data.htsBean;
        this.setState({
          harmonizedTariffScheduleData: harmonizedTariffScheduleData,
        });
        this.disable();
      }
      this.openHarmonizedTariffScheduleEntryForm();
    }
  };

  editHarmonizedTariffSchedule = (code) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = code;
    if (
      SecurityAccessManager.HarmonizedTariffScheduleMaintenanceView_IsAccessible()
    ) {
      MasterService.readHarmonizedTariffSchedule(
        readrestInput,
        this.editHarmonizedTariffScheduleResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  save = () => {
    this.saveHarmonizedTariffSchedule();
  };

  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeHarmonizedTariffScheduleEntryForm();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };

  openHarmonizedTariffScheduleEntryForm = () => {
    this.setState({
      isHarmonizedTariffScheduleListFormOpen: false,
      isHarmonizedTariffScheduleEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowNodes: false,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
    });
    this.hideAlertCallBack();
  };

  closeHarmonizedTariffScheduleEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isHarmonizedTariffScheduleListFormOpen: true,
      isHarmonizedTariffScheduleEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      isShowCode: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
    });
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };

  onChange = (e) => {
    let harmonizedTariffScheduleData = this.state.harmonizedTariffScheduleData;
    harmonizedTariffScheduleData[e.target.name] = e.target.value;
    this.setState({
      harmonizedTariffScheduleData: harmonizedTariffScheduleData,
    });
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.opentypeforms();
    }, 200);
  };
  opentypeforms = () => {
    let harmonizedTariffScheduleData = this.state.harmonizedTariffScheduleData;
    this.editHarmonizedTariffSchedule(harmonizedTariffScheduleData.code);
  };

  loadHarmonizedTariffScheduleResponse = (response) => {
    if (response.data != null && response.data.htsPageList != null) {
      let hts = new Array();
      if (!isEmptyArray(response.data.htsPageList.hts)) {
        hts = response.data.htsPageList.hts;
        hts.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
      }
      let pageList = this.state.pageList;
      pageList.totalCount = response.data.htsPageList.totalCount;
      pageList.currentPage = response.data.htsPageList.currentPage;
      pageList.pageSize = response.data.htsPageList.pageSize;
      this.setState({
        harmonizedTariffSchedule_list: hts,
        pageList: pageList,
      });
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  loadPage = (pageNumber) => {
    let criteria = new HTSSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadHarmonizedTariffSchedulePage(pageInput, criteria);
  };
  loadHarmonizedTariffSchedulePage = (pageList, criteria) => {
    let requestInput = new RestHarmonizedTariffScheduleListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    this.state.pageList = pageList;
    if (
      SecurityAccessManager.HarmonizedTariffScheduleMaintenanceView_IsAccessible()
    ) {
      MasterService.getHarmonizedTariffSchedulePageList(
        requestInput,
        this.loadHarmonizedTariffScheduleResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  deleteOnClick = (code) => {
    let criteria = new HTSSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.code = code;
    if (
      SecurityAccessManager.HarmonizedTariffScheduleMaintenanceDelete_IsAccessible()
    ) {
      MasterService.deleteHarmonizedTariffSchedule(
        criteria,
        this.deleteHarmonizedTariffScheduleResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  deleteHarmonizedTariffScheduleResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.harmonizedTariffSchedule_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ harmonizedTariffSchedule_list: sorted });
    }
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />

        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isHarmonizedTariffScheduleListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isHarmonizedTariffScheduleListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
            isShowTitle={true}
          />
        )}

        {this.state.isHarmonizedTariffScheduleListFormOpen && (
          <HarmonizedTariffScheduleListForm
            {...this.state}
            onChange={this.onChange}
            enterKeyEventHandler={this.enterKeyEventHandler}
            opentypeforms={this.opentypeforms}
            deleteOnClick={this.deleteOnClick}
            editHarmonizedTariffSchedule={this.editHarmonizedTariffSchedule}
            handleSortingChange={this.handleSortingChange}
          />
        )}

        {this.state.isHarmonizedTariffScheduleEntryFormOpen && (
          <HarmonizedTariffScheduleEntryForm
            {...this.state}
            onChange={this.onChange}
          />
        )}
      </div>
    );
  }
}

function HarmonizedTariffScheduleAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <HarmonizedTariffScheduleList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default HarmonizedTariffScheduleAttributeModule;
